import {Component, HostListener, Inject, OnDestroy, OnInit, PLATFORM_ID} from '@angular/core';
import {ShareMetaSeoService} from '../../shared/services/share-meta-seo.service';
import {isPlatformBrowser} from "@angular/common";

@Component({
  selector: 'gryf-home',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy {
  isScrolled = false;
  video;

  constructor(
    private share: ShareMetaSeoService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (isPlatformBrowser(this.platformId)) {
      if (window.scrollY === 0) {
        this.isScrolled = false;
        if (isPlatformBrowser(this.platformId)) {
          document.getElementById('logo1').style.display = 'block';
          document.getElementById('logo2').style.display = 'none';
          document.getElementById('navbar').classList.remove('navbar-light');
          document.getElementById('navbar').classList.add('navbar-dark');
        }
      } else {
        this.isScrolled = true;
        if (isPlatformBrowser(this.platformId)) {
          document.getElementById('about').classList.remove('text-white');
          document.getElementById('navbarProducts').classList.remove('text-white');
          document.getElementById('navbarServices').classList.remove('text-white');
          document.getElementById('navbarContacts').classList.remove('text-white');
          document.getElementById('ponuka').classList.remove('text-white');
          document.getElementById('blog').classList.remove('text-white');
          document.getElementById('logo1').style.display = 'none';
          document.getElementById('logo2').style.display = 'block';
          document.getElementById('navbar').classList.remove('navbar-dark');
          document.getElementById('navbar').classList.add('navbar-light');
        }
      }
    }
  }

  ngOnInit(): void {
    this.share.createLinkForCanonicalURL();
    if (isPlatformBrowser(this.platformId)) {
      scrollTo(0, 0);
      document.getElementById('about').classList.add('text-white');
      document.getElementById('navbarProducts').classList.add('text-white');
      document.getElementById('navbarServices').classList.add('text-white');
      document.getElementById('navbarContacts').classList.add('text-white');
      document.getElementById('blog').classList.add('text-white');
      document.getElementById('ponuka').classList.add('text-white');
      if (this.isScrolled) {
        document.getElementById('navbar').classList.add('navbar-light');
      } else {
        document.getElementById('navbar').classList.add('navbar-dark');
      }
    }
  }

  ngOnDestroy(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.isScrolled) {
        document.getElementById('navbar').classList.remove('navbar-light');
      } else {
        document.getElementById('navbar').classList.remove('navbar-dark');
      }
    }
  }

  closeNavBar(): void {
    if (isPlatformBrowser(this.platformId)) {
      document.getElementById('navbarCollapse').classList.remove('show');
    }
  }
}
